import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconDoc } from 'src/assets/svg/icon-doc.svg';
import { ReactComponent as IconCattle } from 'src/assets/svg/icon-cattle.svg';
import { ReactComponent as IconFolder } from 'src/assets/svg/icon-folder.svg';
import { ReactComponent as IconForm } from 'src/assets/svg/icon-form.svg';
import { ReactComponent as IconStats } from 'src/assets/svg/icon-stats.svg';
import { faTshirt, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import styled, { css } from 'styled-components';
import LoadingIndicator from 'src/components/LoadingIndicator';
import { useDispatch, useSelector } from 'react-redux';
import {
  getProfile, getHelptexts, getPrognosisRegistrationConfig, getPrognosisRegistrationIsAvailible,
  getIsSuperuser,
} from 'src/store/profile/profile.selectors';
import { dateStrToNorwegianDateFormat } from 'src/utils/date.utils';
import { profileActions } from 'src/store/profile/profile.actions';
import Cookies from 'js-cookie';
import { accountingsActions } from 'src/store/accountings/accountings.actions';
import {
  getBrandingColor, colorTypes, getBrandingStyleOverride, styleOverrides, getIsFontSizeIsHeader,
} from 'src/branding';
import { getFeaturesEnabled } from 'src/slaughterhouseSpecific';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { useToast } from 'src/components/Toast';
import { initiateBrandingClothesRedirect } from 'src/utils/brandingclothes.utils';
import {
  getDocuments,
  getDashboardStatistics,
  getAnimalKindsWithStats,
  getSlaughterhouseStatistics,
  getSlaughtersList,
  getFarmerStatistics,
} from '../../store/accountings/accountings.selectors';
import { formatAmount } from '../Accountings/util';
import { allTimePeriods, kindToDisplay, timePeriodKindSubkindsForAllFarmerStats } from '../Statistics/utils';
import Carousel from '../../components/Carousel';
import { routes } from '../routes.manifest';
import {
  Page,
  Column,
  Row,
  Cell,
  Label,
  Icon,
  LineSeparator,
  LinkLabel,
} from '../../components/Layout';
import { backendUrl, disableBrandingClothes } from '../../config';
import axiosInstance from 'src/axios-instance';

export const desktopBreakpointSize = '820px';

const ItemWrapper = styled(Cell)`
flex-direction: column;
position: relative;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 1em;
  margin: 1.3em 2.6em;
  cursor: pointer;
  text-decoration: none;

  @media only screen and (max-width: 600px) {
    margin: 1em;
  }
`;

const IconLink = styled(ItemWrapper.withComponent(Link))`
`;

const IconBadge = styled.div`
  display: flex;
  flex: 0 0 auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  border-radius: 1.3em;
  width: 5em;
  height: 5em;
  margin-bottom: 8px;
  background: #fff;
  transition: background-color 0.1s ease-out;

  svg {
    width: 50%;
    transition: transform 0.1s ease-out;

    path {
      fill: ${getBrandingColor(colorTypes.primary)};
    }
  }

  :hover {
    background: ${getBrandingColor(colorTypes.primary)};

    svg {
      path {
        fill: #fff;
      }
    }
  }
`;

const IconBadgeClothes = styled(IconBadge)`
  svg{
    path{
      fill: transparent;
      stroke: ${getBrandingColor(colorTypes.primary)};
      stroke-width: 50;
    }
  }

  :hover{
    svg{
      path{
        stroke: white;
        fill: transparent;
      }
    }
  }
`;

const ButtonOpenPrognosisRegistration = styled.div`

`;

export const IconBadgeNumber = styled.div`
  position: absolute;
  top: -0.45em;
  right: -0.45em;
  width: 1.8em;
  line-height: 1.8;
  font-size: 1em;
  background-color: ${getBrandingColor(colorTypes.iconNotificationCount)};
  text-align: center;
  color: #fff;
  border-radius: 50%;

  ${({ small }) => small
    && css`
      top: -0.45em;
      right: 0.5em;
      width: 1.8em;
      line-height: 1.8;
      font-size: 1rem;
    `}
`;

const StatisticsWrapper = styled(Column)`
  @media screen and (min-width: ${desktopBreakpointSize}) {
    padding: 1rem;
    padding-top: 1.1rem;
    width: 80vw;
    max-width: 660px;
    background-color: white;
    position: relative;
    align-self: center;
    margin: 0;
    margin-top: 80px;
  }
`;

const LastAccountingWrapper = styled(Row)`
  padding: 1.3em 2.6em;

  @media screen and (min-width: ${desktopBreakpointSize}) {
    padding: 1.3em 1.6em;
  }
`;

const Balance = styled(Row)`
  margin: 0 1.3em;
  padding: 1.3em 1.3em;

  margin-bottom: ${({ hasSibling }) => (hasSibling ? '0' : '10px')};

  background: ${getBrandingColor(colorTypes.balanceBg)};
  flex-wrap: wrap;
  @media screen and (min-width: ${desktopBreakpointSize}) {
    margin: 0 0.5em;
  }
  @media screen and (max-width: ${desktopBreakpointSize}) {
    margin-right: 2em;
  }

`;

const StatisticsData = styled(Label)`
  align-self: center;
  font-size: 3em;
  color: ${getBrandingColor(colorTypes.primary)};
  font-weight: bold;
  ${getBrandingStyleOverride(styleOverrides.boldText)};
`;

const AnimalHeader = styled(Label)`
  text-align: center;
  margin-top: 0.5em;
  top: 0.5em;
  margin-bottom: 0;
  position: absolute;
  width: 100%;
  font-style: italic;
`;

const ShortcutsBg = styled(Column)`
  background-color: ${getBrandingColor(colorTypes.secondaryBackground)};
  padding-bottom: 7em;
`;

const Shortcuts = styled(Column)`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  padding-top: 30px;
  padding-bottom: 0;
  flex-wrap: wrap;
  width: 500px;
  grid-gap: 2em;

  > *{
    margin: 0;
    width: fit-content;
    align-self: flex-start;
  }

  @media screen and (min-width: ${desktopBreakpointSize}) {
    /*Display the shortscuts-rows in one line*/
    flex-direction: row;
    ${Row} {
      height: fit-content;
    }
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: ${desktopBreakpointSize}) {
    width: min-content;
    margin-left: auto;
    margin-right: auto;
    grid-gap: 3em 4em;
   }
`;

const StyledPage = styled(Page)`
  padding: 0;
  padding-bottom: 0;
  @media screen and (min-width: ${desktopBreakpointSize}) {
    background-color: ${getBrandingColor(colorTypes.secondaryBackground)};
  }

  @media screen and (max-width: ${desktopBreakpointSize}) {
    ${getBrandingStyleOverride(styleOverrides.dashboardTabletMobileSize)};
  }
`;

const BalanceTxt = styled(Label)`
  ${getBrandingStyleOverride(styleOverrides.balanceTxt)};
`;

const Dashboard = () => {
  const dispatch = useDispatch();
  const toast = useToast();
  const profile = useSelector(getProfile);
  const farmerStatistics = useSelector(getFarmerStatistics);
  const animalKindsWithFarmerStats = useSelector(getAnimalKindsWithStats);
  const subkindKeepingStatistics = animalKindsWithFarmerStats?.data?.kinds_with_stats;

  useEffect(() => {
    if (
      !profile.has_cattle.has_cattle
      && !profile.has_cattle.isFetching
      && !profile.has_cattle.error
    ) {
      dispatch(profileActions.fetchHasCattle());
    }
    if (!profile.is_superuser.isFetching && !profile.is_superuser.error) {
      dispatch(profileActions.fetchIsSuperuser());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (!helptexts.isFetching) {
      const now = new Date();
      if (
        helptexts.lastFetched === null
        || now.getTime() - helptexts.lastFetched.getTime() > 600000
      ) {
        dispatch(profileActions.fetchHelptexts());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const helptexts = useSelector(getHelptexts);

  const [unreadEnrolmentCount, setUnreadEnrolmentCount] = useState(null);

  const [unreadDocumentsCount, setUnreadDocumentsCount] = useState(null);
  const [documentsLastRead, setDocumentsLastRead] = useState(null);

  const [unreadAccountingsCount, setUnreadAccountingsCount] = useState(null);
  const [accountingsPostedLastRead, setAccountingsPostedLastRead] = useState(
    null,
  );
  const [accountingsTempLastRead, setAccountingsTempLastRead] = useState(null);

  const [balanceAndDebit, setBalanceAndDebit] = useState(null);

  const slaughtersList = useSelector(getSlaughtersList);
  const isLoading = (profile.has_cattle.has_cattle === null || profile.has_cattle.isFetching)
    && !profile.has_cattle.error;
  useEffect(() => {
    let unreadCount = 0;
    if (slaughtersList.postedSlaughters) {
      if (accountingsPostedLastRead) {
        if (!accountingsPostedLastRead.timestamp) {
          unreadCount = unreadCount + slaughtersList.postedSlaughters.length;
        } else {
          const date = new Date(accountingsPostedLastRead.timestamp);
          slaughtersList.postedSlaughters.map((slaughter) => {
            if (slaughter?.date && new Date(slaughter.date) > date) {
              unreadCount = unreadCount + 1;
            }
            return undefined;
          });
        }
      }
    } else if (!slaughtersList.isFetchingPosted && !slaughtersList.error) {
      dispatch(accountingsActions.fetchPostedSlaughterList());
    }
    if (slaughtersList.tempSlaughters) {
      if (accountingsTempLastRead && getFeaturesEnabled().temp_accountings) {
        if (!accountingsTempLastRead.timestamp) {
          unreadCount = unreadCount + slaughtersList.tempSlaughters.length;
        } else {
          const date = new Date(accountingsTempLastRead.timestamp);
          slaughtersList.tempSlaughters.map((slaughter) => {
            if (slaughter.date && new Date(slaughter.date) > date) {
              unreadCount = unreadCount + 1;
            }
            return undefined;
          });
        }
      }
    } else if (!slaughtersList.isFetchingTemp && !slaughtersList.error) {
      dispatch(accountingsActions.fetchTempSlaughterList());
    }
    setUnreadAccountingsCount(unreadCount);
  }, [
    accountingsPostedLastRead,
    accountingsTempLastRead,
    dispatch,
    slaughtersList.error,
    slaughtersList.isFetchingPosted,
    slaughtersList.isFetchingTemp,
    slaughtersList.postedSlaughters,
    slaughtersList.tempSlaughters,
  ]);

  const documents = useSelector(getDocuments);
  const statistics = useSelector(getDashboardStatistics);
  const animalKindsWithStats = useSelector(getAnimalKindsWithStats);
  const slaughterhouseStatistics = useSelector(getSlaughterhouseStatistics);
  const prognosisRegistrationConfig = useSelector(getPrognosisRegistrationConfig);

  const enableWorkwearPunchout = useSelector(getIsSuperuser);

  useEffect(() => {
    if (documents.data) {
      const {
        invoices,
        credit_notes,
        accountings,
        open_posts,
        withdrawals,
      } = documents.data;

      if (documentsLastRead) {
        if (!documentsLastRead.timestamp) {
          setUnreadDocumentsCount(
            invoices.length
            || 0 + credit_notes.length
            || 0 + accountings.length
            || 0 + open_posts.length
            || 0 + withdrawals.length
            || 0,
          );
          return;
        }

        setUnreadDocumentsCount(
          invoices.reduce(
            (count, { id, date }) => (new Date(date) > new Date(documentsLastRead.timestamp)
              ? count + 1
              : count),
            0,
          )
          + credit_notes.reduce(
            (count, { id, date }) => (new Date(date) > new Date(documentsLastRead.timestamp)
              ? count + 1
              : count),
            0,
          )
          + accountings.reduce(
            (count, { id, date }) => (new Date(date) > new Date(documentsLastRead.timestamp)
              ? count + 1
              : count),
            0,
          )
          + open_posts.reduce(
            (count, { id, date }) => (new Date(date) > new Date(documentsLastRead.timestamp)
              ? count + 1
              : count),
            0,
          )
          + withdrawals.reduce(
            (count, { id, date }) => (new Date(date) > new Date(documentsLastRead.timestamp)
              ? count + 1
              : count),
            0,
          ),
        );
      }
    } else if (!documents.isFetching && !documents.error) {
      dispatch(accountingsActions.fetchDocuments());
    }
  }, [
    dispatch,
    documents.data,
    documents.error,
    documents.isFetching,
    documentsLastRead,
  ]);

  useEffect(() => {
    if (!statistics.data && !statistics.isFetching && !statistics.error) {
      dispatch(accountingsActions.fetchDashboardStatistics());
    }
  }, [dispatch, statistics.data, statistics.error, statistics.isFetching]);

  useEffect(() => {
    if (!farmerStatistics.isFetchingAll && !farmerStatistics.data && subkindKeepingStatistics) {
      const toFetch = timePeriodKindSubkindsForAllFarmerStats(kindToDisplay, subkindKeepingStatistics, allTimePeriods);
      dispatch(accountingsActions.fetchAllFarmerStatistics({
        timeFrame: Array.from(toFetch.allTimePeriods).join(';'),
        kind: Array.from(toFetch.allKinds).join(';'),
        subkind: Array.from(toFetch.allSubkinds).join(';'),
      }));
    }
  }, [farmerStatistics, subkindKeepingStatistics, animalKindsWithStats, dispatch]);

  useEffect(() => {
    if (!animalKindsWithStats.data && !animalKindsWithStats.isFetching && !animalKindsWithStats.error) {
      dispatch(accountingsActions.fetchAnimalKindsWithStats());
    }
  }, [animalKindsWithStats.data, animalKindsWithStats.error, animalKindsWithStats.isFetching, dispatch]);

  useEffect(() => {
    if (!slaughterhouseStatistics.data && !slaughterhouseStatistics.isFetching && !slaughterhouseStatistics.error) {
      dispatch(accountingsActions.fetchSlaughterhouseStatistics());
    }
  }, [slaughterhouseStatistics.data, slaughterhouseStatistics.error, slaughterhouseStatistics.isFetching, dispatch]);

  useEffect(() => {
    if (!Cookies.get('logged-in')) {
      return;
    }

    axiosInstance
      .request({
        method: 'GET',
        url: `${backendUrl}/api/registered_enrolment_unread`,
        withCredentials: true,
      })
      .then(({ data }) => data && setUnreadEnrolmentCount(data.count));
    axiosInstance
      .request({
        method: 'GET',
        url: `${backendUrl}/api/hasread/documents/notification`,
        withCredentials: true,
      })
      .then(({ data }) => setDocumentsLastRead(data));
    axiosInstance
      .request({
        method: 'GET',
        url: `${backendUrl}/api/hasread/accountings-posted/notification`,
        withCredentials: true,
      })
      .then(({ data }) => setAccountingsPostedLastRead(data));
    axiosInstance
      .request({
        method: 'GET',
        url: `${backendUrl}/api/hasread/accountings-temp/notification`,
        withCredentials: true,
      })
      .then(({ data }) => setAccountingsTempLastRead(data));

    axiosInstance
      .request({
        method: 'GET',
        url: `${backendUrl}/api/profile/balance`,
        withCredentials: true,
      })
      .then(({ data }) => setBalanceAndDebit(data));
  }, []);

  const statisticsIsForMultipleAnimals = () => (
    Object.getOwnPropertyNames(
      statistics.data['last-settlement'],
    ).filter(
      (animalType) => statistics.data['last-settlement'][animalType].count > 0,
    ).length > 1
  );

  const prognosisRegistationIsAvailible = useSelector(getPrognosisRegistrationIsAvailible);

  return (
    <StyledPage title="Dashboard" paddingBottom="0">
      {(isLoading && <LoadingIndicator withText />) || (
        <>
          <StatisticsWrapper>
            {[{
              amount: balanceAndDebit?.balance_this_year,
              text: 'Avregningsbeløp hittil i år:',
              enabled: true,
            },
            {
              amount: balanceAndDebit?.debit_amount_total,
              showIfZero: true,
              text: 'Utestående varekjøp per dato',
              enabled: getFeaturesEnabled().debit_total_in_dashboard,
            }].filter((e) => e.enabled).map((info, idx, arr) => (
              <Balance
                hasSibling={arr.length > 1}
                key={idx}
                grow
                style={
                  idx === 1 && { paddingTop: '0.2em' } || {}
                }
              >
                <Row>
                  <Label align="flex-end" marginBottom="0.2em">
                    {info.text}
                  </Label>
                </Row>
                <Cell grow />
                <Row>
                  <Label align="flex-end" marginBottom="0.2em" serif>
                    {'kr '}
                  </Label>
                  <BalanceTxt
                    lineHeight="1"
                    align="flex-end"
                    font="serif"
                    size="3em"
                    name="balanceTxt"
                    margin="0 8px"
                  >
                    {info.amount || (info.showIfZero && info.amount === '0.00') ? formatAmount(info.amount) : '-'}
                  </BalanceTxt>
                  <Label align="flex-end" marginBottom="0.2em" serif>
                    inkl. mva.
                  </Label>
                </Row>
              </Balance>
            ))}
            <LastAccountingWrapper grow padding="1.3em 2.6em">
              <Label>
                Siste avregning:
                {' '}
                {!slaughtersList.isFetching
                  && slaughtersList.postedSlaughters
                  && slaughtersList.postedSlaughters[0]?.date
                  && dateStrToNorwegianDateFormat(
                    slaughtersList.postedSlaughters[0].date,
                  )}
                {!slaughtersList.isFetching
                  && slaughtersList.postedSlaughters
                  && slaughtersList.postedSlaughters.length === 0
                  ? 'Fant ingen'
                  : ''}
                {slaughtersList.error ? 'Kunne ikke hente' : ''}
              </Label>

              <Cell grow />
              <LinkLabel to={routes.accountingsPosted}>Se detaljer</LinkLabel>
            </LastAccountingWrapper>
            <Cell grow margin="0 1.3em">
              <LineSeparator />
            </Cell>
            <Cell grow style={{ minHeight: '170px' }}>
              {(statistics.data && statistics.data['last-settlement'] && (
                <Carousel
                  slides={[
                    !!statistics.data['last-settlement'].pigs.count && (
                      <div style={{ position: 'relative' }}>
                        {statisticsIsForMultipleAnimals() && (
                          <AnimalHeader>Gris</AnimalHeader>
                        )}
                        <Row
                          justify="center"
                          paddingTop="2.6em"
                          paddingBottom="1em"
                          columnInMobile
                        >
                          <Cell grow>
                            <StatisticsData>
                              {Math.round(
                                statistics.data['last-settlement'].pigs
                                  .meat_percent_avg,
                              )}
                              <Label inline marginBottom="-8px" size="1rem">
                                %
                              </Label>
                            </StatisticsData>
                            <Label align="center">Kjøttprosent</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                          <Cell grow>
                            <StatisticsData>
                              {Math.round(
                                statistics.data['last-settlement'].pigs
                                  .weight_kg_avg,
                              )}
                              <Label inline marginBottom="-8px" size="1rem">
                                kg
                              </Label>
                            </StatisticsData>
                            <Label align="center">Snitt vekt</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                          <Cell grow>
                            <StatisticsData>
                              {
                                statistics.data['last-settlement'].pigs
                                  .count
                              }
                            </StatisticsData>
                            <Label align="center">Antall slakt</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                        </Row>
                      </div>
                    ),
                    !!statistics.data['last-settlement'].sheep
                      .count && (
                      <div style={{ position: 'relative' }}>
                        {statisticsIsForMultipleAnimals() && (
                          <AnimalHeader>Småfe</AnimalHeader>
                        )}
                        <Row
                          justify="center"
                          paddingTop="2.6em"
                          paddingBottom="1em"
                          columnInMobile
                        >
                          <Cell grow>
                            <StatisticsData>
                              {
                                statistics.data['last-settlement'].sheep
                                  .classification_avg
                              }
                            </StatisticsData>
                            <Label align="center">Snitt klasse</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                          <Cell grow>
                            <StatisticsData>
                              {Math.round(
                                statistics.data['last-settlement'].sheep
                                  .weight_kg_avg,
                              )}
                              <Label inline marginBottom="-8px" size="1rem">
                                kg
                              </Label>
                            </StatisticsData>
                            <Label align="center">Snitt vekt</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                          <Cell grow>
                            <StatisticsData>
                              {
                                statistics.data['last-settlement'].sheep
                                  .count
                              }
                            </StatisticsData>
                            <Label align="center">Antall slakt</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                        </Row>
                      </div>
                    ),
                    !!statistics.data['last-settlement'].cattle
                      .count && (
                      <div style={{ position: 'relative' }}>
                        {statisticsIsForMultipleAnimals() && (
                          <AnimalHeader>Storfe</AnimalHeader>
                        )}
                        <Row
                          justify="center"
                          paddingTop="2.6em"
                          paddingBottom="1em"
                          columnInMobile
                        >
                          <Cell grow>
                            <StatisticsData>
                              {
                                statistics.data['last-settlement']
                                  .cattle.classification_avg
                              }
                            </StatisticsData>
                            <Label align="center">Snitt klasse</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                          <Cell grow>
                            <StatisticsData>
                              {Math.round(
                                statistics.data['last-settlement']
                                  .cattle.weight_kg_avg,
                              )}
                              <Label inline marginBottom="-8px" size="1rem">
                                kg
                              </Label>
                            </StatisticsData>
                            <Label align="center">Snitt vekt</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                          <Cell grow>
                            <StatisticsData>
                              {
                                statistics.data['last-settlement']
                                  .cattle.count
                              }
                            </StatisticsData>
                            <Label align="center">Antall slakt</Label>
                            <Label align="center" color="#b6b6b6">
                              (siste leveranse)
                            </Label>
                          </Cell>
                        </Row>
                      </div>
                    ),
                  ].filter((any) => any)}
                />
              ))
                || (Object.getOwnPropertyNames(animalKindsWithStats.data?.kinds_with_stats || {}).every((time_frame) => (animalKindsWithStats.data?.kinds_with_stats?.[time_frame] || {})?.has_slaughters === false) && (
                  <Row justify="center" paddingTop="5em" />
                ))
                || (statistics.isFetching && (
                  <Row justify="center" paddingTop="5em">
                    <Label color="#4a4a4a">Laster statistikk...</Label>
                  </Row>
                ))}
            </Cell>
          </StatisticsWrapper>

          <ShortcutsBg grow>
            <Shortcuts justify="center">
              <IconLink to={routes.registerEnrolment}>
                <IconBadge>
                  <IconForm />
                  {!!unreadEnrolmentCount && (
                    <IconBadgeNumber>
                      {unreadEnrolmentCount > 9 ? '9+' : unreadEnrolmentCount}
                    </IconBadgeNumber>
                  )}
                </IconBadge>
                <Label color={getBrandingColor(colorTypes.fontHeader)} noWrap>
                  Innmelding
                </Label>
              </IconLink>
              <IconLink to={getFeaturesEnabled().temp_accountings ? routes.accountingsTemp : routes.accountingsPosted}>
                <IconBadge>
                  <IconDoc />
                  {!!unreadAccountingsCount && (
                    <IconBadgeNumber>
                      {unreadAccountingsCount > 9
                        ? '9+'
                        : unreadAccountingsCount}
                    </IconBadgeNumber>
                  )}
                </IconBadge>
                <Label color={getBrandingColor(colorTypes.fontHeader)} noWrap>
                  Avregninger
                </Label>
              </IconLink>

              <IconLink to={routes.documents}>
                <IconBadge>
                  <IconFolder />
                  {!!unreadDocumentsCount && (
                    <IconBadgeNumber>
                      {unreadDocumentsCount > 9 ? '9+' : unreadDocumentsCount}
                    </IconBadgeNumber>
                  )}
                </IconBadge>
                <Label color={getBrandingColor(colorTypes.fontHeader)} noWrap>
                  Dokumenter
                </Label>
              </IconLink>
              {profile.has_cattle.has_cattle !== null
                && !(
                  profile.has_cattle
                  && profile.has_cattle.has_cattle === false
                ) && (
                  <IconLink to={routes.myCattle}>
                    <IconBadge>
                      <IconCattle />
                    </IconBadge>
                    <Label color={getBrandingColor(colorTypes.fontHeader)} noWrap>
                      Mine storfe
                    </Label>
                  </IconLink>
                )}
              <IconLink to={routes.statistics}>
                <IconBadge>
                  <IconStats />
                </IconBadge>
                <Label color={getBrandingColor(colorTypes.fontHeader)} noWrap>
                  Statistikk
                </Label>
              </IconLink>

              {getFeaturesEnabled().branding_clothes && (
                <IconLink
                  to={enableWorkwearPunchout ? '#' : routes.brandingClothes}
                  onClick={enableWorkwearPunchout
                    ? (e) => initiateBrandingClothesRedirect(e, dispatch, toast)
                    : undefined}
                >
                  <IconBadgeClothes>
                    <Icon icon={faTshirt} style={{ fontSize: '2em' }} />
                  </IconBadgeClothes>
                  <Label color={getBrandingColor(colorTypes.fontHeader)} noWrap>
                    Profileringsklær
                  </Label>
                </IconLink>
              )}

              {getFeaturesEnabled().return_form
                && (
                  <IconLink to={routes.returnFormHelp}>
                    <IconBadgeClothes>
                      <Icon icon={faRedoAlt} style={{ fontSize: '2em' }} />
                    </IconBadgeClothes>
                    <Label color={getBrandingColor(colorTypes.fontHeader)} noWrap>
                      Retur
                    </Label>
                  </IconLink>
                )}

              {prognosisRegistationIsAvailible
                && (
                  <ItemWrapper onClick={() => dispatch(profileActions.openPrognosisRegistration())}>
                    <IconBadge>
                      <Icon icon={faChartBar} style={{ fontSize: '2.4em' }} />
                    </IconBadge>
                    <Label color={getBrandingColor(colorTypes.fontHeader)}>
                      Oppdatering av prognose
                    </Label>
                  </ItemWrapper>
                )}

            </Shortcuts>
          </ShortcutsBg>
        </>
      )}
    </StyledPage>
  );
};

export default Dashboard;
